import { CEadVal, CEadValPos, DocumentFile, Entwurf, NEadSubPos } from '../../../models/Zelos/ZelosModels';

export type State = {
  entwurfe: Array<Entwurf>;
  neadsubpos: Array<NEadSubPos>;
  neadsubDoc: DocumentFile | null;
  ceadval: Array<CEadVal>;
  ceadvalpos: Array<CEadValPos>;
};

export const state: State = {
  entwurfe: sessionStorage.getItem('neadsub') != null ? JSON.parse(sessionStorage.neadsub) : new Array<Entwurf>(),
  neadsubpos: sessionStorage.getItem('neadsubpos') != null ? JSON.parse(sessionStorage.neadsubpos) : new Array<NEadSubPos>(),
  neadsubDoc: null,
  ceadval: sessionStorage.getItem('ceadval') != null ? JSON.parse(sessionStorage.ceadval) : new Array<CEadVal>(),
  ceadvalpos: sessionStorage.getItem('ceadvalpos') != null ? JSON.parse(sessionStorage.ceadvalpos) : new Array<CEadValPos>(),
};
